module.exports = __webpack_public_path__ + "media/images/signups/card/family-card-adb2dc25b828ba1352da12e6da5de4f5.png";